/* eslint-disable max-len */
const languageEn = {
    Captions: {
        on: 'captions on',
        off: 'captions off',
    },
    alphabets: {
        Alphabets: 'Alphabets',
        Help: 'Help',
        Reset: 'Reset',
        Reveal: 'Reveal',
        title: 'Matching Young With Parents',
        help_title: 'Help',
        helpText1:
      'Choose a letter and then click it to reveal an image of something that can be described by a word beginning with that letter.',
        helpText2:
      "Ask your students to guess the word that's associated with the letter and image.",
        helpText3:
      'Once your students have guessed, click “Reveal” to complete the word.',
        helpText4: 'Click the back button to return to the main alphabet screen.',
        header_main: 'Matching Young with Parents',
        subheader_main:
      'To play the game, choose a picture and see if you can match the offspring to the parent.',
        reset_button: 'Reset',
        option_header_main: 'Click on the correct offspring for this adult.',
        invalid_selection:
      "Good try, but that's not the offspring of this parent. Take a closer look.",
        valid_selection:
      "That's right! You've matched the parent tiger with its offspring. Both have striped fur.",
        reset_confirm: 'Are you sure?',
        modal_reset_confirm: 'Yes',
        modal_reset_no: 'No',
        caption: '[happy music chiming]',
    },
    MatchingYoungWithParents: {
        hiss: '[alligator hisses]',
        ping: '[bell pings]',
        quack: '[duck quacks]',
        yelp: '[sea lion yelps]',
        roar: '[tiger roars]',
        title: 'Matching Young With Parents',
        help_title: 'Help',
        helpText1: 'Find the right parent for each offspring.',
        helpText2: 'Click on who you think the offspring might be.',
        helpText3:
      'If you make a wrong choice, the picture you chose will disappear and you can guess again until you get it right.',
        helpText4:
      'Once you have chosen the right offspring, click ‘back’ and try again with a different animal or plant.',
        header_main: 'Matching Young with Parents',
        subheader_main:
      'To play the game, choose a picture and see if you can match the offspring to the parent.',
        reset_button: 'Reset',
        option_header_main: 'Click on the correct offspring for this adult.',
        invalid_selection:
      "Good try, but that's not the offspring of this parent. Take a closer look.",
        valid_selection:
      "That's right! You've matched the parent tiger with its offspring. Both have striped fur.",
        reset_confirm: 'Are you sure?',
        modal_reset_confirm: 'Yes',
        modal_reset_no: 'No',
        Tiger: 'Tiger',
        striped_fur: 'striped fur',
        Duck: 'Duck',
        flat_bills: 'flat bills and webbed feet for swimming',
        Alligator: 'Alligator',
        armor_plated_skin: 'the same body and head shape with armor-plated skin',
        Sea_lion: 'Sea lion',
        flipper_shape: 'the same flipper shape and small ears',
        needle_shaped_leaves: 'needle-shaped leaves',
        Bean_plant: 'Bean plant',
        long_stems: 'long stems and heart-shaped leaves',
        Tiger_cub: 'Tiger cub',
        Leopard_cub: 'Leopard cub',
        Lion_cub: 'Lion cub',
        Kitten: 'Kitten',
        Duckling: 'Duckling',
        Gosling: 'Gosling',
        Flamingo: 'Flamingo',
        Penguin: 'Penguin',
        Chameleon: 'Chameleon',
        Trutle: 'Trutle',
        Iguana: 'Iguana',
        Arctic_seal: 'Arctic seal',
        Grey_seal: 'Grey seal',
        Manatee: 'Manatee',
        Pine_tree_offspring: 'Pine tree offspring',
        Pine_tree: 'Pine tree',
        Coconut_tree: 'Cocout tree offspring',
        Oak_tree: 'Oak tree offspring',
        Ash_tree: 'Ash tree offspring',
        Corn_offspring: 'Corn offspring',
        Bean_plant_offspring: 'Bean plant offspring',
        Tamato_plant: 'Tamato plant offspring',
        Squash_plant: 'Squash plant offspring',
        correct_match:
      "That's right! You've matched the parent *PARENT_NAME* with its offspring. Both have *TRAITS*.",
        wrongOffspring:
      "Good try, but that's not the offspring of this parent. Take a closer look.",
        notItEither:
      'That’s not it either. Look for a trait that only one young organism shares with the adult.',
        correctAnswerAnimal:
      'This one is the correct answer. Both the adult and the young *PARENT_NAME* have *TRAITS*.',
    },
    Landforms: {
        title: 'Landforms',
        welcome: 'Welcome to Rio de Janeiro',
        clickPin: ' Click on the pins to find out more about each landform!',
        start: 'Start',
        show: 'Show to flow of matter and nutrients through the system.',
        ChristTheRedeemerStatue: 'Christ the Redeemer Statue',
        ChristRedeemerDescription:
      'This is a giant statue on top of a mountain near the city of Rio de Janeiro. It is world famous and you can see the statue from very far away.',
        RodrigoDeFreitasLagoon: 'Rodrigo de Freitas Lagoon',
        LagoonDescription:
      'There is a large lake called a ‘lagoon’ in the city of Rio de Janeiro. It is called a lagoon and not a ‘bay’ because it is cut off from the sea by a thin piece of land.',
        CopacabanaBeach: 'Copacabana Beach',
        CopacabanaDescription:
      'This is a world famous beach where people go to enjoy the sun and relax by the sea.',
        RioNiteroiBridge: 'Rio-Niterói Bridge',
        BridgeDescription:
      'This massive bridge goes across Guanabara Bay and is the sixth longest bridge in the world. It connects the city of Rio de Janeiro on one side of the bridge, to the city of Niterói on the other side.',
        MorroDoisIrmaos: 'Morro Dois Irmãos',
        MorroDescription:
      'Morro Dois Irmãos is called Two Brothers Hill in English. It has one of the most amazing views in Rio de Janeiro. You can see Christ the Redeemer Statue, Rodrigo de Freitas Lagoon and Copacabana beach from the top of the hill.',
    },
    MakingChangesEcosystem: {
        Algae: 'Algae',
        DecreaseNumber: 'Decrease number',
        KeepTheSame: 'Keep the same',
        IncreaseNumber: 'Increase number',
        AlgaeDescription:
      'Algae are tiny plants that live in the water. They get their matter from water and air, and get their energy from the sun.',
        InsectLarvae: 'Insect larvae',
        InsectLarvaeDescription:
      'Many insects lay their eggs in water, and the insect young, called larvae, live in the water before they transform into adult insects. These insect larvae get their matter and energy from eating <b>algae</b>.',
        NativeTrout: 'Native trout',
        NativeTroutDescription:
      'The native trout live in the lake, rivers and streams, and swim upstream every year to reproduce. They get their matter and energy from eating <b>insect larvae</b>.',
        NonNativeTrout: 'Non-native trout',
        NoLakeTrout: 'No lake trout',
        AddLakeTrout: 'Add lake trout',
        AddMoreLakeTrout: 'Add more lake trout',
        NonNativeTroutDescription:
      "These non-native trout live at the bottom of the lake, so they don't get eaten by bears. They grow much bigger than the native trout. They eat both <b>insect larvae</b> and <b>native trout</b>.",
        Bear: 'Bear',
        BearDescription:
      'These bears fish in the streams for food. They get matter and energy from eating <b>native trout</b>.',
        GoingUp: 'going up',
        NoActionPossible: 'No action possible',
        ChangesInOrganisms:
      'What happens when the number of organisms in an ecosystem changes?',
        IntroducingNonNative:
      'How does introducing a non-native organism affect an ecosystem?',
    },
    PlantFactory: {
        fruit: 'fruit',
        flower: 'flower',
        leaf: 'leaf',
        stem: 'stem',
        root: 'root',
        strawberry: 'strawberry',
        plumTree: 'plum tree',
        pumpkin: 'pumpkin',
        yellowPondLily: 'yellow pond lily',
        tomato: 'tomato',
        oregonGrape: 'oregon grape',
        crazyPlant: 'crazy plant',
        team: 'team',
        plant: 'plant',
        help: 'Help',
        step1: '1. Type your team name in the box, then click OK.',
        step2: '2. Choose a plant.',
        step3:
      '3. Drag and drop the plant parts to build your plant model. When your model is finished, use the words to label it.',
        step4: '4. Select download to save your model.',
        step5:
      '5. Select back to return to the main menu. If you have time, choose another plant to build.',
        plantFactory: 'plant factory',
        typeTeamName: 'type your team name:',
        ok: 'OK',
        choosePlant: 'choose a plant',
        download: 'download',
    },
    SafariSounds: {
        Tiger: 'Tiger',
        Frog: 'Frog',
        Elephant: 'Elephant',
        Snake: 'Snake',
        Parrot: 'Parrot',
        Monkey: 'Monkey',
        Bee: 'Bee',
        Human: 'Human',
        title: 'Safari Sounds',
        help: 'Help',
        guessText: 'Guess what made each sound.',
        playOnce: 'Click "play once" to play the sound once.',
        playLoop: 'Click "play loop" to play the sound on a loop.',
        pause: 'Click the pause icon to stop playback.',
        answerReveal:
      'After your students have guessed what made the sound, click the tile to reveal the answer.',
        whatAnimal: 'What made that sound?',
        reset: 'Reset',
        sure: 'Are you sure?',
        yes: 'Yes',
        no: 'No',
        btnPlayOnce: 'Play once',
        btnPause: 'Pause',
        btnPlayLoop: 'Play loop',
        btnPauseLoop: 'Pause loop',
        roar: '[roaring]',
        croak: '[croaking]',
        toot: '[tooting]',
        squak: '[squawking]',
        whoop: '[whooping]',
        buzz: '[buzzing]',
        laugh: '[laughing]',
        hiss: '[hissing]',
    },
    AnimalSounds: {
        title: 'Sounds',
        helpTitle: 'Help',
        helpText1: 'Guess what made each sound.',
        helpText2: 'Click "play once" to play the sound once.',
        helpText3: 'Click "play loop" to play the sound on a loop.',
        helpText4: 'Click the pause icon to stop playback.',
        helpText5: 'After your students have guessed what made the sound, click the tile to reveal the answer.',
        headerMain: 'What Made That Sound?',
        resetButton: 'Reset',
        resetConfirm: 'Are you sure?',
        modalResetConfirm: 'Yes',
        modalResetNo: 'No',
        playOnce: 'Play once',
        pause: 'Pause',
        playLoop: 'Play loop',
        pauseLoop: 'Pause loop',
        lion: 'Lion',
        cat: 'Cat',
        dolphin: 'Dolphin',
        rattlesnake: 'Rattlesnake',
        frog: 'Frog',
        cricket: 'Cricket',
        wolf: 'Wolf',
        human: 'Human',
        roaring: '[roaring]',
        whistling: '[whistling]',
        meow: '[meowing and purring]',
        rattling: '[rattling]',
        croaking: '[croaking]',
        chirping: '[chirping]',
        howling: '[howling]',
        laughing: '[laughing]',
    },
    CertificateOfMaterials: {
        title: 'Certificate of Materials',
        back: 'Back',
        next: 'Next',
        caption: '[happy music playing]',
        juniorResearcher: 'Junior Researcher',
        JRTask1: 'Describe objects by their properties.',
        JRTask2: 'Sort objects into groups based on properties.',
        JRTask3: 'Compare and contrast the properties of two objects.',
        technicianTesting: 'Technician of Testing',
        TTTask1:
      'Test different materials for the properties of hardness, flexibility, absorbency, and strength.',
        TTTask2: 'Rate materials in order of how much they show a property.',
        TTTask3: 'Choose the best materials for a specific purpose.',
        engineerExcellence: 'Engineer of Excellence',
        EETask1: 'Build towers out of three different materials.',
        EETask2: 'Test your towers for strength.',
        EETask3: 'Write a report about the results of your test.',
        laboratoryLeader: 'Laboratory Leader',
        LLTask1: 'Give examples of reversible and irreversible changes.',
        LLTask2:
      'Explain how something can be made using the terms solid, liquid, melting, and freezing.',
        LLTask3: 'Solve a problem involving reversible/irreversible changes.',
        professorProperties: 'Professor of Properties',
        PPTask1: 'Build two different bridges using the same materials.',
        PPTask2: 'Test the strength of the bridges.',
        PPTask3: 'Compare the results of the bridge tests.',
    },
    AnimalLifeCycle: {
        title: 'Animal Life Cycles',
        reset: 'Reset',
        check: 'Check',
        caption: '[happy music twinkling]',
        congratulations:
      'Congratulations. You have selected the correct life cycle for this animal.',
        Amphibians: {
            title: 'Amphibians',
            frog: 'Frog',
            frogSubtitle:
        'Drag the images and labels to the correct places in a frog life cycle.',
            eggs: 'Eggs',
            embryo: 'Embryo',
            tadpole: 'Tadpole',
            froglet: 'Froglet',
            findMate: 'Find Mate',
            newt: 'Newt',
            newtSubtitle:
        'Drag the images and labels to the correct places in a newt life cycle.',
            layEggs: 'Lay Eggs',
            developingEggs: 'Developing Eggs',
            gilledLarvae: 'Gilled Larvae',
            adult: 'Adult',
        },
        Birds: {
            title: 'Birds',
            cassowary: 'Cassowary',
            cassowarySubtitle:
        'Drag the images and labels to the correct places in a cassowary life cycle.',
            hatchling: 'Hatchling',
            eggsHatch: 'Eggs Hatch',
            layEggs: 'Lay Eggs',
            incubateEggs: 'Incubate Eggs',
            findMate: 'Find Mate',
            hummingbird: 'Hummingbird',
            hummingbirdSubtitle:
        'Drag the images and labels to the correct places in a hummingbird life cycle.',
            adult: 'Adult',
        },
        Reptiles: {
            title: 'Reptiles',
            lizard: 'Lizard',
            lizardSubtitle:
        'Drag the images and labels to the correct places in a lizard life cycle.',
            youngLizard: 'Young Lizard',
            egg: 'Egg',
            hatchling: 'Hatchling',
            adult: 'Adult',
            findMate: 'Find Mate',
        },
    },
    MediaGallery: {
        title: 'Media gallery',
        heading: 'Media Gallery: Reversible and Irreversible',
        juice: 'Juice',
        egg: 'Egg',
        butter: 'Butter',
    },
    EarthChanges: {
        caption: 'Captions on',
        earthChanges: 'Earth Changes',
        title: 'Earth Changes Media Gallery',
        buttonText1: 'QUICK OR SLOW',
        buttonText2: 'EROSION CHANGES',
        quickOrSlow: 'Quick or Slow',
        volcanicEruption: 'Volcanic Eruption',
        video: 'Video',
        textWithPhotos: 'Text with Photos',
        eruptionMtStHelen: 'Eruption of Mount St. Helen',
        lavaFlow: 'Lava Flow',
        eruptionTungarahua: 'Eruption of Tungarahua',
        description1:
      '<ul><li>A volcano is an opening in the Earth’s crust where molten rock and gases erupt or pour out. Volcanoes are found on land and under the ocean. Eruptions happen when pressure builds inside Earth. Volcanoes erupt in different ways. Some eruptions are strong and blow very, very hot lava into the air. Rocks, hot gases, and ash may also be sent flying. Sometimes, lava escapes through the opening in the crust as a gentle flow. The Kilauea volcano in Hawaii slowly flows from openings in the crust.</li><li><br>All volcanoes are dangerous. They can change whole landscapes in a few days, hours, or even minutes. An eruption like this happened in Rome a long time ago. Mount Vesuvius erupted. Hot lava, gas, and rocks poured down the side of the mountain. It covered the nearby city of Pompeii. It took just a little more than a day. Many people in Pompeii did not escape in time. They were buried under ash and rocks.</li></ul>',
        flashFlood: 'Flash Flood',
        photos: 'Photos',
        floodedHouse: 'Flooded House',
        floodedRoad: 'Flooded Road',
        floodedTown: 'Flooded Town',
        landslide: 'Landslide',
        glacierValleyFormation: 'Glacier Valley Formation',
        glacierValley: 'Glacier in Valley',
        largeValley: 'Large Valley',
        mountainGlacier: 'Mountain Glacier',
        description2:
      '<ul><li>Glaciers are large rivers of hard ice that slowly slide down a mountainside. Glaciers are only found in places on Earth with very cold temperatures. Long ago, glaciers were all over Earth. Scientists know this by looking at the shapes of valleys and canyons. They compare the shapes to areas where glaciers still exist. It takes thousands of years for glaciers to carve out valleys in Earth.</li><li><br>Glaciers can be called the planet’s most powerful natural bulldozer. Gravity and pressure move the large ice rivers very slowly down mountains. The glacier picks up rocks and rubble. The rocks drag along the bottom of the glacier as it moves. This causes erosion. The glacier is like a gigantic piece of Earth sandpaper. It scrapes and carves out Earth. When the glacier moves down to a warmer point, it melts. It leaves the rocks and rubble behind. The icy melted water moves into lakes, rivers, and oceans. After many years of the ice moving, melting, and carving, a big valley is left behind. A glacier’s work is done.</li></ul>',
        weatheringAndErosion: 'Weathering and Erosion',
        windErosionRocks: 'Wind Erosion on Rocks',
        description3:
      '<ul><li>Earth’s landscape changes over long periods of time. Water, wind, plants, and animals can all weather and erode land surfaces. Weathering is when rocks are broken into smaller pieces. Erosion is when those smaller pieces are moved away. As the pieces move, they grind against the surface they are moving upon.</li><li><br>Some of these changes occur because of water or wind. As rain falls and water flows, or freezes and melts, it wears on Earth’s surface. Wind that blows against rocks erodes their surfaces. A landmass breaks down bit by bit.</li><li><br>It is moved or built up by the water or wind.</li><li><br>This weathering and erosion sometimes create arches, or tall rock towers called hoodoos. Hoodoos can take millions of years to form.</li><li>Many people like to view these rock formations when they visit national parks, for example. If they come back to the same place years later, they might not even notice that anything has changed. Only small clues show the effects of erosion.</li></ul>',
        erosionSolutions: 'Erosion Solutions',
        erosionEngineering: 'Erosion Engineering',
        levee: 'Levee',
        description4:
      '<ul></li>As rivers flow, they erode the land on either side of the river. This makes the river wider and the riverbanks lower. Over time, riverbanks may become so wide that the river finds a new path. When the river erodes a new path, this will flood a new area of land that might contain roads or buildings! Low riverbanks are also a problem because the river water can spill over them. This causes flooding. Building levees along the riverbanks can prevent this erosion. Levees are large structures found along riverbanks and coastlines. They are usually made from big piles of earth. They are wide at the bottom and narrower on top, and slope away from the river. Levees form a long, sloping ‘wall’ alongside a river or coast.  That helps to prevent flooding. Levees stop the river getting wider. They keep the riverbanks high to hold back the water and stop flooding.</li><li><br>Levees protect against erosion, but they can also be eroded by the river, the rain and the wind.  A levee can be broken if it is weakened too much by erosion. For example, if there is a big flood and it is too strong for the levee to hold the water back. Grasses, trees or shrubs can be planted on top of the levee to make levees stronger. The plant roots help to hold the earth of the levee in place. Sometimes, plant roots aren’t strong enough to keep the levee in place. So, other building materials can be used to protect a levee. Materials such as concrete, large rocks, or boulders can be used.</li><li><br>The main problem with building levees is the cost. Building a levee alongside a long river or coast takes a lot of time and effort from lots of workers. Paying all these workers costs a lot of money.</li><li><br>Fun fact: In ancient Egypt, people built levees along the river Nile.</li></ul>',
        breakwater: 'Breakwater',
        description5:
      '<ul></li>Breakwaters are found on the coast. They protect the coast from wave erosion. They can also protect against wind and rain erosion. Breakwaters are large structures. They are  made from huge, heavy rocks. They look a little bit like a large, rocky wall. They are built in shallow areas of the sea. Offshore breakwaters can be single, long stretch of rocky wall.  They can also be broken up into multiple smaller rocky walls.</li><li><br>Breakwaters help to slow down waves.  They make the waves smaller before they hit the shore. Sometimes, if there is a big storm, the very big waves cannot always be stopped. Breakwaters are also helpful in stopping the movement of sand across the seafloor. As waves travel up the beach they can pick up sand and carry it away. This erodes the beach. Breakwaters slow down the waves and stop the sand from being carried too far away. Some people think that breakwaters are ugly, and that they spoil the view.</li></ul>',
        seawall: 'Seawall',
        description6:
      '<ul></li>On the coast, high tides can lead to flooding. Strong waves can be dangerous. They can damage roads and buildings. Many low lying areas build a seawall to protect their coast. Seawalls are usually made from concrete, large rocks or steel.  They are very tall – much taller than you! Seawalls protect the coast by stopping waves from reaching the shore. </li><li><br>The coast is constantly changing due to erosion from waves, rivers, wind and rain. To protect the shore from erosion, seawalls need to be very large. This means they take up a lot of space.  They can get in the way of plants and animals that live on the shore. </li><li><br>Seawalls are strong and can last a long time. Some seawalls built by the Romans over 2000 years ago are still standing today! However, seawalls can be damaged by very big waves during a storm. They must be regularly checked for damage after a storm. Building and maintaining seawalls can be expensive.  If the shoreline is long, as a lot of building materials are needed to build the wall.</li></ul>',
        retainingWall: 'Retaining Wall',
        description7:
      '<ul></li>Erosion from wind and rain can be a big problem in hilly areas. Soil on the slopes of a hill can be washed to the bottom by heavy rain. Rain can wash away paths and cause earth to build up on roads. Constant erosion can weaken the underground rock causing it to come loose. The rocks, soil and mud can rush down the hill in a landslide when lots of earth and mud comes loose. That is dangerous because the loose rocks and soil could hit buildings, roads or even people!</li><li><br>Retaining Walls are built on the hillside to stop soil from moving downwards. Retaining Walls are solid structures. They are most often made of concrete, stone, metal or wood. They are built like a wall of a house, but are much thicker. This helps hold back the earth on the hillside behind the walls. Multiple retaining walls can be built behind the one in front as you move up a hillside. Lots of retaining walls built one in front of the other can look like a giant staircase when you stand at the bottom of the hill and look up.  The soil between the walls can be filled in and flattened to stop plants sliding down the hill. </li><li><br>Another way to protect a hillside is to cover it with erosion netting. Erosion netting can be made from natural fibres or plastic. The netting  is used to cover the soil. This stops the wind from blowing the soil away. Erosion netting also slows down erosion by rain. When rainwater flows down the side of a hill, it can carry soil down with it. With erosion netting, the straw and heavy netting can help to slow down the water stopping it from carrying so much soil down the hill. </li><li><br>Retaining Walls and netting can be very useful. Some people think they make the hillside look ugly. If there is a very big landslide, the walls and netting can fail.</li></ul>',
        naturalSolutions: 'Natural Solutions',
        breachNourishment: 'Beach Nourishment',
        description8:
      '<ul></li>Erosion, by wind, rain or waves, causes sand to be carried away from an area. One way to fix this problem is to add the sand back where it has disappeared. This allows the erosion to continue without too much damage to the beach. Erosion is happening all the time, so the sand will need to be replaced regularly. That is very time-consuming.</li><li><br><br>Sand dunes are a natural way to protect a beach from erosion. They form when sand is blown and collects in one area. Over time, more and more sand collects and the dunes get bigger. Sand dunes are very useful for slowing down wind or water that could carry away the sand, rocks or earth. Sand dunes take a long time to form on their own. One way we can protect beaches from erosion is by copying nature and building sand dunes ourselves. It takes a lot of sand to build dunes big enough to protect against erosion. To do this we need to move a lot of sand from one place to another.  That can take a long time.</li></ul>',
        managedRetreat: 'Managed Retreat',
        description9:
      "<ul></li>One solution when erosion becomes a big problem is to move all the people away from that area. This is called a 'managed retreat'. With all the people gone, things like flooding or an advancing shoreline happen without risk of harm. Managed retreat causes the least amount of damage to the environment. However, managed retreat can be difficult because new homes must be found for the people who had lived there.</li><li><br><br>Moving all the people away from the area means they will no longer be affected by wind, rain, river or wave erosion. This also means that the buildings left behind in that area can no longer be used. In coastal areas, the shoreline can be left to move inwards so empty buildings can fall into the sea. Managed retreat is usually done in areas that are facing very bad erosion problems. It is used when other solutions have already been tried and failed. It is most used in areas that are low down or close to the ocean. This is where there is a high risk of flooding.</li></ul>",
        sandDuneVegetation: 'Sand Dune Vegetation',
        description10:
      '<ul></li>Strong winds can cause soil to tumble down hills. Heavy rain can wash the soil away. Planting grass or other plants can help. The roots will help to protect the soil by holding it in place. The roots of plants and grasses at the beach can help to hold the sand on sand dunes. Keeping the sand in place will help to protect the dunes against strong winds, rain and waves. The roots hold the soil together underground. The parts above ground can help to slow down running water and gusts of wind. Water and wind cannot carry away as much soil or sand when they are moving more slowly. </li><li><br><br>The more plants there are are on a hillside or sand dune, the more roots will grow into the soil. This will hold the soil in place and protect it from erosion. Many plants and grasses are fragile and easily damaged.  The plants might be washed away by heavy rain or waves if there is a big storm. This means they will need to be re-planted.</li></ul>',
        windbreaks: 'Windbreaks',
        description11:
      '<ul></li>Farmers often need large areas of open space to plant crops. It is difficult to stop the soil from being blown away by the wind in these areas. If the soil is blown away, farmers can’t plant any crops. Rows of trees can be planted on farms or plains as ‘windbreaks’ to protect the soil. The trees help to slow down the wind so it isn’t as strong. Then the wind can’t blow as much soil away. Windbreaks protect against erosion from the wind.</li><li><br><br>The main problem with planting trees as windbreaks is that trees take a long time to grow. Taller trees take up more space and are better at slowing down wind.   A mixture of different tree species often makes the best windbreaks. That is because they are different sizes. Smaller trees can help to fill in the spaces between larger trees. Trees that are tightly packed together are better at slowing down wind to protect areas from erosion.</li></ul>',
    },
    MakingWaves: {
        title: 'Making Waves',
        hotspot1: 'Rock drops from here',
        hotspot2a: 'Place',
        hotspot2b: 'rock here',
        description1a: 'Drag the duck to point ',
        description1b: 'A, B',
        description1c: ' or ',
        description1d: 'C.',
        description2: 'Choose the size of rock to drop:',
        description3: 'Here it goes!',
        description4part1: 'Your results:',
        description4part2: 'Duck position:',
        description4part3: 'Rock size:',
        description4part4: 'Wave height:',
        caption: '[water splashes]',
        next: 'Next',
        small: 'Small',
        large: 'Large',
        drop: 'Drop!',
        startOver: 'Start Over',
    },
    EarthMap: {
        title: 'Earth Map',
        lake: 'Lake',
        snow: 'Ice/Snow',
        river: 'River',
        ocean: 'Ocean',
        tip: 'TIP: Double tap on a pin to remove it.',
    },
    TimeLapse: {
        timeLapse: 'Time-Lapse',
        welcomeTour: 'Welcome to the Time-Lapse Tour',
        start: 'Start',
        videoTitle: 'Video title',
        columbiaGlacier: '1. Columbia Glacier, AK, US',
        amazon: '4. Amazon Rain Forest, Rondônia, Brazil',
        padma: '7. Padma River, Bangladesh',
        mountStHelens: '2. Mount St. Helens, WA, US',
        dubai: '5. Dubai, UAE',
        yellowRiverDelta: '8. Yellow River Delta, China',
        capeCod: '3. Cape Cod, MA, US',
        aralSea: '6. Aral Sea, Kazakhstan and Uzbekistan',
        shanghai: '9. Shanghai, China',
        credit: 'Credit: NASA Earth Observatory',
    },
    SolarCooker: {
        smallBox: 'Small Box',
        wedge: 'Wedge',
        cone: 'Cone',
        cylinder: 'Cylinder',
        umbrella: 'Umbrella',
        whitePaper: 'White Paper',
        cardboard: 'Cardboard',
        wood: 'Wood',
        aluminumFoil: 'Aluminum Foil',
        white: 'White',
        lightGray: 'Light Gray',
        darkGray: 'Dark Gray',
        black: 'Black',
        choose: 'Choose...',
        timeMinutes: '*TIME* minutes',
        solarCooker: 'Solar Cooker',
        howCook: 'How can you cook using the Sun’s energy?',
        designSolarCooker:
      'You need a combination of colors, shapes and materials in order to design a solar cooker that will boil water. The best combination will boil water the fastest!',
        chooseFollowing: 'Choose the following:',
        typeOfCooker: '1 - The type of cooker.',
        interiorType: '2 - The type of interior for the cooker walls.',
        colorOfCan: '3 - The color of can that holds the water.',
        pressStart:
      'Once you have done that, press “Start” to see just how good your solar cooker is at boiling water.',
        heating: 'Heating...',
        instructions: 'Instructions:',
        chooseOptions:
      'Choose a combination of the options below and see how long it takes for the water to boil.',
        cooker: 'Type of Cooker',
        interior: 'Type of Interior',
        color: 'Color of Can',
        youChose: 'You Chose:',
        largeBox: 'Large Box',
        woodInterior: 'Wood Interior',
        whiteCan: 'White Can',
        yourSolarCooker: 'Your Solar Cooker boiled water in:',
        minutes: '107 minutes',
        reset: 'Reset',
        startOver: 'Start Over',
        start: 'Start',
    },
    WeatherAnalyzer: {
        title: 'Weather Analyser',
        yuma: 'Yuma, AZ',
        minneapolis: 'Minneapolis, MN',
        mobile: 'Mobile, AL',
        apr: 'Apr',
        jun: 'Jun',
        jul: 'Jul',
        avgMonthlyTemp: 'Average Monthly Temperature',
        avgMonthlyPrecip: 'Average Monthly Precipitation',
        avgPrecipMm: 'Average Precipitation (mm)',
        avgMonthlyWind: 'Average Monthly Wind Speed',
        avgWindKmHr: 'Average Wind Speed (km/hr)',
        diffTempDegrees:
      'The difference between the hottest and coldest is *DIFF* degrees.',
        diffWindKmHr:
      'The difference between the fastest and slowest is *DIFF* km/hr.',
        diffPrecipMm: 'The difference between the highest and lowest is *DIFF* mm.',
        chooseLocation: 'Choose location',
        chooseDataType: 'Choose type of data:</div>',
        for: 'for',
        chooseLocationAndData:
      'Choose a location and the type of weather data you are looking for, then start the interactive.',
        start: 'Start',
        avgMonthlyTempMinneapolis:
      'Average Monthly Temperature for Minneapolis, MN',
        avgTempF: 'Average Temperature (&deg;F)',
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
        enterYourData: 'Enter your data:',
        calculateRange: 'Calculate range',
    },
    IceAge: {
        title: 'Ice Age Survival',
        nextPeriod: 'Next Period',
        startOver: 'Start Over',
        periodTime: 'Period *TIME_PERIOD*',
        iceAgeSurvival: 'Ice Age Survival',
        averageTempDesc:
      'The average temperature during the ice age was 12 degrees colder than it is today. This meant that even places where forests and grass grew were much colder places than they are today. When the global temperature changes it also changes the habitat that plants and animals live in, making it difficult to survive. Can you help these animals survive the Ice Age?',
        start: 'Start',
        dragAnimals:
      'Drag animals onto the map to see how they survive in a changing climate.',
        mammoths: 'Mammoths',
        squirrels: 'Squirrels',
        addHumans: 'Add humans',
        startSimulation: 'Start Simulation',
        legend: 'Legend:',
        glacier: 'Glacier',
        forest: 'Forest',
        shrubs: 'Shrubs',
        grass: 'Grass',
        desert: 'Desert',
        lakeTrout: 'Lake trout',
        playSimulation: 'Play Simulation',
        reset: 'Reset',
        goingDown: 'going down',
        startOverConfirm: 'Are you sure you want to start over?',
        yes: 'Yes',
        no: 'No',
    },
    SpaceAdventure: {
        caption: '[happy music playing]',
        title: 'Space Adventures',
        next: 'Next',
        back: 'Back',
        knowSeeSunDay: 'I know I can see the Sun during the day.',
        knowSeeMoonNight: 'I know I can see the Moon at night.',
        nameObjectsSky: 'I can name other objects in the sky.',
        rocketLauncher: 'Rocket Launcher',
        skyGazer: 'Sky Gazer',
        knowObjectsSmaller: 'I know that objects farther away look smaller.',
        knowSunFartherMoon: 'I know that the Sun is farther away than the Moon.',
        makeRocketLaunchMoon: 'I can make a rocket and launch it at the Moon!',
        starBlazer: 'Star Blazer',
        nameEightPlanets: 'I can name the 8 planets in the Solar System.',
        makeSolarSystemModel: 'I can make a model of the Solar System.',
        knowPlanetsOrbitSun: 'I know that the planets orbit the Sun.',
        planetHopper: 'Planet Hopper',
        exploreMysteryPlanet: 'I can explore a mystery planet.',
        makeModelVolcano: 'I can make a model volcano.',
        nameRockyPlanets: 'I can name the rocky planets.',
        astronaut: 'Astronaut',
        planSpaceMission: 'I can plan a space mission to a planet.',
        designRocketPlanet: 'I can design a rocket to take me to my planet.',
        knowPlanetsSpaceMission:
      'I know which planets I will see on my space mission.',
    },
    LandformPatterns: {
        water: 'Water',
        pin: 'Double tap on a pin to remove it.',
    },
    AmusementPark: {
        title: 'Amusement Park',
        heading: 'Amusement Park Forces',
        welcomeText: 'Click on the pins to find out more about each ride',
        start: 'Start',
        bumperCar: 'Bumper Cars',
        bumperCarDescription:
      'As the bumper cars collide, they change speed and direction. What is happening to the forces acting on them?',
        riverLog: 'River Rapids Log Flume',
        riverLogDescription:
      "The flume's speed slows as it reaches the bottom of the slope. Are the forces acting on it balanced or unbalanced?",
        rollerCoaster: 'Roller Coaster',
        rollerCoasterDescription:
      'What happens to the motion of the roller coaster car as it shoots down the slope? Are the forces balanced or unbalanced?',
        monorail: 'Funland Monorail',
        monorailDescription:
      'The monorail takes a route right around the park. The cars move at a constant speed. Are the forces balanced or unbalanced?',
    },
    FoodChain: {
        title: 'Food Chain',
        helpTitle: 'Help',
        text1: 'Show the flow of matter and energy through the system.',
        text2:
      'Drag the organisms, energy and matter arrows into the box in the correct order.',
        text2a: 'You may place up to two arrows between each organism.',
        text3:
      'When you think you are finished, select "Check" to check your answer. ',
        text5: 'If you want to start again, select "Reset" ',
        reset: 'Reset',
        start: 'Start',
        energy: 'Energy',
        matter: 'Matter',
        check: 'Check',
        controlLabel: 'Level',
        levelDropdown: 'Potato',
        notification: 'Well done! Now try a different food chain.',
        errorNotification: 'Try Again',
        introSubTitle:
      'Drag the organisms and arrows in the correct order to show the flow of matter and energy through the system.',
        pineForestFoodChain: 'Pine Forest Food Chain',
        dragText:
      'Drag the pictures and arrows in the correct order. You can have one or two arrows between pictures.',
        sun: 'Sun',
        plant: 'Plant',
        mouse: 'Mouse',
        eagle: 'Eagle',
        twinkle: '[happy music twinkling]',
        oceanFoodChain: 'Ocean Food Chain',
        algae: 'Algae',
        scallop: 'Scallop',
        harborSeal: 'Harbor Seal',
        orcaWhale: 'Orca Whale',
        oakWoodlandFoodChain: 'Oak Woodland Food Chain',
        grass: 'Grass',
        cricket: 'Cricket',
        frog: 'Frog',
        owl: 'Owl',
    },
    VirtualMicroscope: {
        title: 'Virtual Microscope',
        introText:
      'Grab your lab coat and get up close and personal with living things! Using Twig’s virtual microscope, you can get a closer look at what exactly living things are made of. You might think you know what plants and animals look like, but under a microscope, things look very different!',
        getReadyText:
      'Get ready to explore the parts that make up plants and animals, including humans. You will even be able to see if your brain looks anything like a rat’s brain!',
        start: 'Start',
        slideCaption: '[slide clicks into place]',
        zoomCaption: '[dial clicking]',
        selectSample:
      'Select a sample from the cabinet and drag it onto the microscope to get started.',
        clear: 'Clear',
        viewSlide: 'View Slide',
        heartMuscle: 'heart muscle tissue',
        zoom: 'Zoom level',
        low: 'low',
        high: 'high',
        humans: 'Humans',
        hight: 'high',
        lung: 'Lung',
        alveoli: 'Alveoli',
        epitheliumTissue: 'Epithelium Tissue',
        intestine: 'Intestine',
        smoothMuscleTissue: 'Smooth Muscle Tissue',
        heart: 'Heart',
        heartMuscleTissue: 'Heart Muscle Tissue',
        brain: 'Brain',
        nervousTissueInBrain: 'Nervous Tissue in Brain',
        otherAnimals: 'Other Animals',
        ratBrainTissue: 'Rat Brain Tissue',
        frogLargeIntestineTissue: 'Frog Large Intestine Tissue',
        catAlveoli: 'Cat Alveoli',
        plants: 'Plants',
        stalk: 'Stalk',
        broccoliStalk: 'Broccoli Stalk',
        root: 'Root',
        onionRootTip: 'Onion Root Tip',
        leaf: 'Leaf',
        orchidLeaf: 'Orchid Leaf',
        microorganisms: 'Microorganisms',
        salmonellaBacteria: '<i>Salmonella</i> Bacteria',
        algae: 'Algae',
        amoeba: 'Amoeba',
        yeast: 'Yeast',
    },
    Stargazer: {
        title: 'Stargazer',
        introduction:
      'With Twig’s Stargazer, you can look at the starry sky at any time! You could travel back in time, and see what the stars looked like hundreds of years ago. Or, you could go far into the future! By selecting a time, day, month and year, you can see what the stars are up to whenever you like – even when it’s daytime!',
        explore:
      'Get ready to explore constellations, the stars that make them up, and when and where they appear in the sky. What patterns will you notice in the stars?',
        start: 'Start',
        dateTime: 'Date/Time',
        constellations: 'Constellations',
        off: 'Off',
        on: 'On',
        all: 'All',
        individual: 'Individual',
        virgo: 'Virgo',
        leo: 'Leo',
        lyra: 'Lyra',
        sagittarius: 'Sagittarius',
        pegasus: 'Pegasus',
        capricornus: 'Capricornus',
        perseus: 'Perseus',
        cetus: 'Cetus',
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'April',
        may: 'May',
        jun: 'June',
        jul: 'July',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
        distance: 'Distance',
        ly: 'LY',
    },
    WaterConservation: {
        introduction:
      'There are lots of different ways to save water. Some, you probably already know about, but others may surprise you!',
        instructions:
      'As you look around the house, click on objects and appliances in each room to explore your water saving options. Click on the <b>Summary</b> button at the end to see how much water you could save!',
        enterNameTitle: 'Please enter a name/title:',
        start: 'Start',
        waterUseSummary: 'Water Use Summary',
        item: 'Item',
        yourSelection: 'Your Selection',
        avgMonthlyUsage: 'Average Monthly Usage (gallons)',
        newMonthlyUsage: 'New Monthly Usage (gallons)',
        waterConserved: 'Water Conserved (gallons)',
        cost: 'Cost',
        print: 'Print',
        startAgain: 'Start again',
        ok: 'OK',
        title: 'Water Savers',
        kitchen: 'Kitchen',
        backToKitchen: 'Back to Kitchen',
        kitchenSink: 'Kitchen Sink',
        monthlyUsage1000Gal: 'Monthly Usage: 1000 gallons per month',
        addAerator: 'Add Aerator',
        aeratorDescription:
      'An aerator reduces the amount of water that comes out of the faucet.',
        cost5Savings500Gal: 'Cost: $5     Savings: 500 gal',
        useDishwasher: 'Use Dishwasher Instead of Washing Dishes by Hand',
        dishwasherDescription:
      'It takes less water for a dishwasher to wash a full load than it does for you to wash all those dishes by hand.',
        costNoneSavings300Gal: 'Cost: none     Savings: 300 gal',
        bothTogether: 'Both Together',
        cost5Savings550Gal: 'Cost: $5     Savings: 550 gal',
        noChange: 'No Change',
        dishwasher: 'Dishwasher',
        monthlyUsage180Gal: 'Monthly Usage: 180 gallons per month',
        newDishwasher: 'New Dishwasher',
        newDishwasherDescription:
      'Modern dishwashers use half as much water as old dishwashers.',
        cost500Savings90Gal: 'Cost: $500     Savings: 90 gal',
        runOnlyFullLoads: 'Run Only Full Loads',
        fullLoadDescription:
      'Don’t run the dishwasher when you only have a few dirty dishes. Wait until the dishwasher is full to turn it on.',
        costNoneSavings90Gal: 'Cost: none     Savings: 90 gal',
        cost500Savings135Gal: 'Cost: $500     Savings: 135 gal',
        bathroom: 'Bathroom',
        backToBathroom: 'Back to Bathroom',
        toBathroom: 'To Bathroom',
        shower: 'Shower',
        monthlyUsage6000Gal: 'Monthly Usage: 6,000 gallons per month',
        installLowFlowShowerhead: 'Install New Low-Flow Showerhead',
        lowFlowShowerheadDescription:
      'A low-flow showerhead uses less water but still gives a good shower.',
        cost25Savings3000Gal: 'Cost: $25     Savings: 3,000 gal',
        cutShowerTime: 'Cut Shower Time in Half',
        cutShowerTimeDescription:
      'You can save water by being quick in the shower.',
        costNoneSavings3000Gal: 'Cost: none     Savings: 3,000 gal',
        cost25Savings4500Gal: 'Cost: $25     Savings: 4,500 gal',
        toilet: 'Toilet',
        monthlyUsage3000Gal: 'Monthly Usage: 3,000 gallons per month',
        installLowFlowToilet: 'Install New Low-Flow Toilet',
        lowFlowToiletDescription:
      'A low-flow toilet uses much less water per flush than a regular toilet.',
        cost500Savings2232Gal: 'Cost: $500     Savings: 2,232 gal',
        waterBottleInToilet: 'Put Water Bottle in Toilet Tank',
        waterBottleDescription:
      'A bottle or other container, placed in the toilet tank, uses less water per flush.',
        bathroomSink: 'Bathroom Sink',
        monthlyUsage1800Gal: 'Monthly Usage: 1,800 gallons per month',
        cost5Savings600Gal: 'Cost: $5     Savings: 600 gal',
        turnOffWater: 'Turn off Water While Brushing Teeth',
        turnOffWaterDescription:
      'Turning off the tap while brushing your teeth saves water.',
        costNoneSavings360Gal: 'Cost: none     Savings: 360 gal',
        cost5Savings960Gal: 'Cost: $5     Savings: 960 gal',
        laundryRoom: 'Laundry Room',
        backToLaundryRoom: 'Back to Laundry Room',
        toLaundryRoom: 'To Laundry Room',
        washingMachine: 'Washing Machine',
        monthlyUsage1500Gal: 'Monthly Usage: 1,500 gallons per month',
        buyNewWasher: 'Buy New Washer',
        newWasherDescription:
      'A high-efficiency washer uses about half as much water than a regular machine.',
        cost600Savings650Gal: 'Cost: $600     Savings: 650 gal',
        fullLoadWasherDescription:
      'Don’t run the washer when you only have a few dirty clothes. Wait until you have enough for a full load to turn it on.',
        costNoneSavings375Gal: 'Cost: none     Savings: 375 gal',
        cost600Savings1000Gal: 'Cost: $600     Savings: 1,000 gal',
        pipes: 'Pipes',
        monthlyUsage110Gal:
      'Monthly Usage: 110 gallons per month (water lost in leaks)',
        monthlyUsage110GalNoLeak: 'Monthly Usage: 110 gallons per month',
        fixPipeLeaks: 'Fix Pipe Leaks',
        fixPipeLeaksDescription:
      'Many households lose water through leaky pipes. Hire a plumber to help find leaks and fix them.',
        cost200Savings110Gal: 'Cost: $200     Savings: 110 gal',
        outside: 'Outside',
        goOutside: 'Go Outside',
        garden: 'Garden',
        monthlyUsage420Gal: 'Monthly Usage: 420 gallons per month',
        monthlyUsage420GalAvg:
      'Monthly Usage: 420 gallons per month (average: based on 200 ft sq)',
        replacePlants: 'Replace with Native and Water-Saving Plants',
        replacePlantsDescription:
      'Replace flowers and plants that need a lot of water with native and drought-tolerant plants.',
        cost200Savings260Gal: 'Cost: $200     Savings: 260 gal',
        addMulch: 'Add mulch',
        addMulchDescription: 'Add mulch to help keep water in the soil.',
        cost50Savings60Gal: 'Cost: $50     Savings: 60 gal',
        cost250Savings270Gal: 'Cost: $250     Savings: 270 gal',
        wateringLawn: 'Watering the Lawn',
        monthlyUsage3000GalAvg: 'Monthly Usage: 3,000 gallons per month (average)',
        waterAtNight: 'Water at Night',
        waterAtNightDescription:
      'Watering at night, when it’s cool, means the water won’t be evaporated by the Sun, so you won’t need to use as much water.',
        costNoneSavings750Gal: 'Cost: none     Savings: 750 gal',
        rainBarrel: 'Rain Barrel',
        rainBarrelDescription:
      'Connect a barrel to the downspout and save the water for your lawn.',
        cost50Savings55Gal: 'Cost: $50     Savings: 55 gal',
        cost50Savings805Gal: 'Cost: $50     Savings: 805 gal',
        totals: 'totals',
        summary: 'Summary',
    },
    Tours: {
        title: '360 Tours',
        selectTile: 'Select a tile to open a 360 panoramic image.',
        selectPoint:
      'Select a point and drag the panorama to rotate it and look around.',
        start: 'Start',
        southKaibab: 'South Kaibab',
        yakiPoint: 'Yaki Point',
        toroweapOverlook: 'Toroweap Overlook',
        southKaibabTrailhead: 'South Kaibab Trailhead',
        southKaibabCanyon: 'South Kaibab, The Grand Canyon',
    },
    SunriseSunsetCalculator: {
        title: 'Sunrise and Sunset Calculator',
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'April',
        may: 'May',
        jun: 'June',
        jul: 'July',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
        distance: 'Distance',
        ly: 'LY',
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        am: 'am',
        pm: 'pm',
        hour: 'hour',
        hours: 'hours',
        minute: 'minute',
        minutes: 'minutes',
        location: 'First, enter a location:',
        oops: 'Oops! Make sure you enter a valid <strong>city</strong> and <strong>state/province/region,</strong> or a <strong>ZIP/postal code',
        pickDate: 'Then, pick a date:',
        reset: 'Reset',
        submit: 'Submit',
        sunrise: 'Sunrise',
        lengthOfDay: 'Length of day',
        sunset: 'Sunset',
        welcome: 'Welcome to the Twig Sunrise/Sunset Calculator!',
        start: 'Start',
        ok: 'OK',
    },
    Ecosystem: {
        title: 'Making Changes to an Ecosystem',
        exploreChanges:
      'Explore what can happen when part of a food web is changed. Increase the number of organisms, decrease the number, or introduce an entirely new kind of organism. You might be surprised by just how much difference one small change can make!',
        start: 'Start',
        level1: 'Level 1',
        level2: 'Level 2',
        lakeTrout: 'Lake trout',
        organism: 'Organism',
        action: 'Action',
        play: 'Play Simulation',
        reset: 'Reset',
        whatsHappening: "What's happening?",
        year: 'Year',
        goingDown: 'going down',
        algae: 'Algae',
        decreaseNumber: 'Decrease number',
        keepSame: 'Keep the same',
        increaseNumber: 'Increase number',
        algaeDescription:
      'Algae are tiny plants that live in the water. They get their matter from water and air, and get their energy from the sun.',
        insectLarvae: 'Insect larvae',
        insectLarvaeDescription:
      'Many insects lay their eggs in water, and the insect young, called larvae, live in the water before they transform into adult insects. These insect larvae get their matter and energy from eating <b>algae</b>.',
        nativeTrout: 'Native trout',
        nativeTroutDescription:
      'The native trout live in the lake, rivers and streams, and swim upstream every year to reproduce. They get their matter and energy from eating <b>insect larvae</b>.',
        nonNativeTrout: 'Non-native trout',
        noLakeTrout: 'No lake trout',
        addLakeTrout: 'Add lake trout',
        addMoreLakeTrout: 'Add more lake trout',
        nonNativeTroutDescription:
      'These non-native trout live at the bottom of the lake, so they don&#39;t get eaten by bears. They grow much bigger than the native trout. They eat both <b>insect larvae</b> and <b>native trout</b>.',
        bear: 'Bear',
        bearDescription:
      'These bears fish in the streams for food. They get matter and energy from eating <b>native trout</b>.',
        goingUp: 'going up',
        noAction: 'No action possible',
        whatHappensChanges:
      'What happens when the number of organisms in an ecosystem changes?',
        introAffect:
      'How does introducing a non-native organism affect an ecosystem?',
    },
    WaveBreakers: {
        title: 'Wave Breakers',
        openOcean: 'Open Ocean',
        coast: 'Coast',
        makeChoices:
      'Make your choices and carefully watch the motion of the kayak.',
        makeChoicesStart:
      'Make your choices and press Start. Carefully watch the motion of the kayak.',
        amplitude: 'Amplitude',
        small: 'Small',
        medium: 'Medium',
        large: 'Large',
        wavelength: 'Wavelength',
        short: 'Short',
        long: 'Long',
        seafloor: 'Seafloor Steepness',
        gentle: 'Gentle',
        moderate: 'Moderate',
        steep: 'Steep',
        start: 'Start',
        stop: 'Stop',
    },
    Thermometer: {
        title: 'Thermometer',
        whatIs: 'What is the weather like today?',
        baltic: 'very cold',
        cold: 'cold',
        mild: 'mild',
        hot: 'hot',
        temp: 'Temperature:',
        check: 'Check',
        enter: 'Please enter a value between 0 and 100.',
        ok: 'OK',
    },
    OurChangingWorld: {
        title: 'Our Changing World',
        MediaGallery: 'Media Gallery: Our Changing World',
        DataInvestigation:
      'Scientists have been gathering and recording data to investigate how the world has been changing over time. Choose a tile below to see what they’ve found so far.',
        SeaLevels: 'Changing Sea Levels',
        SeaLevelsDetails:
      'Data from satellites have shown that sea levels around the world have been changing. This globe is color coded to show the total changes in various areas of the ocean between 1992 and 2014.<br><br>Press play or move the slider to rotate the globe. Use the scale below to determine which areas have small changes and which areas have large changes. Land is shown as dark gray.',
        Credits: 'Credits',
        CreditsDetails:
      'Animation by NASA/Goddard Space Flight Center Scientific Visualization Studio <br>Blue Marble data courtesy of Reto Stockli (NASA/GSFC)',
        Play: 'Play',
        Help: 'Help',
        SeaSurfaceHeightChange: '22-year Sea Surface Height Change',
        ArcticIceGraph:
      'Annual minimum Arctic ice from 1979 to 2016 with a graph overlay',
        SatelliteData:
      'Data from satellites have shown that sea levels around the world have been changing. This globe is color coded to show the total changes in various areas of the ocean between 1992 and 2014.',
        RotateGlobe:
      'Press play or move the slider to rotate the globe. Use the scale below to determine which areas have small changes and which areas have large changes. Land is shown as dark gray.',
        CarbonDioxideMeasurement:
      'Scientists use <b>ppm</b> to measure how many parts of carbon dioxide there are in one million parts of air. These measurements help them record how carbon dioxide levels in the atmosphere change over time.',
        CO2Increase:
      'This visualization shows the increase of carbon dioxide in the atmosphere from the burning of fossil fuels (coal, oil and natural gas) between the years 2011–2012.',
        CO2EmissionsChange:
      'Press play or move the slider to scroll through time. Use the scale below to see which areas had the largest increases in carbon dioxide emissions.',
        TemperatureRecords:
      'Since 1880, scientists have been recording the temperature of many locations around the world. Using that data, they have determined an average temperature (or “normal”). This map shows how the temperature in different places around the world compared to the average.',
        TemperatureChange:
      'Press play or move the slider to see changes over time. Temperatures below average are light blue to dark blue; temperatures above average are yellow to red.',
        ArcticIceTracking:
      'At the North Pole, the amount of ice that covers the Arctic Ocean is an important indicator of global climate. Scientists are able to track the amount of ice using satellites. Each year, they measure the amount of ice covering the Arctic Ocean during the summer. This is when there is the least amount of ice, which they call a “minimum”. This visualization shows how much ice (white) was present at the minimum for the years 1979-2016.',
        SeaIceChange:
      'Press play or move the slider to scroll through time and see how sea ice has been changing.',
        TempDifference: 'Temperature Difference',
        Celsius: 'Celsius',
        PPM: 'ppm',
        ZeroCM: '0 (cm)',
        AnimationNASA: "Animation by NASA's Scientific Visualization Studio",
        SeaIce: 'Changing Sea Ice',
        CO2Emissions: 'Changing Carbon Dioxide Emissions',
        AnimationNOAA:
      'Animation courtesy of Global Monitoring Division, NOAA Earth System Research Laboratory',
        Jan2011: 'Jan 2011',
        Dec2012: 'Dec 2012',
        TempChange: 'Changing Temperatures',
        AnimationNASAData:
      'Animation by NASA/Goddard Space Flight Center Scientific Visualization Studio <br>Data provided by Robert B. Schmunk (NASA/GSFC GISS)',
        Pause: 'Pause',
    },
    Seasons: {
        springFlowers: 'Spring Flowers',
        growLikeFlower: 'Can you grow like a flower?',
        nestEggs: 'Nest Eggs',
        whatHappensNext: 'What happens next?',
        littleLambs: 'Little Lambs',
        animalSounds: 'What sound do these animals make?',
        meltingTreat: 'Melting Treat',
        whyIceCreamMelting: 'Why is the ice cream melting?',
        safeInSun: 'Safe in the Sun',
        protectSkinSun: 'How can we protect our skin from the Sun?',
        whatToWear: 'What to Wear',
        wearWhenWarm: 'What do you wear when it is warm?',
        prepareForWinter: 'Prepare for Winter',
        squirrelDoing: 'What is this squirrel doing?',
        scareSeason: 'Scare Season!',
        celebrateHalloween: 'What do you do to celebrate Halloween?',
        fallingLeaves: 'Falling Leaves',
        pretendFallingLeaf: 'Can you pretend to be a falling leaf?',
        gettingChilly: 'It’s Getting Chilly',
        waterWhenCold: 'What happens to water when it gets really cold?',
        wrapUp: 'Wrap Up!',
        wearWhenCold: 'What do you wear when it is very cold?',
        upClose: 'Up Close',
        snowflakeUpClose: 'What does a snowflake look like up close?',
        whereLeavesGo: 'Where Did the Leaves Go?',
        leavesGrowBack: 'When will these leaves grow back?',
        title: 'Seasons',
        chooseSeason: 'Choose a Season',
        spring: 'Spring',
        summer: 'Summer',
        fall: 'Fall',
        winter: 'Winter',
    },

    BodySystems: {
        title: 'Body Systems',
        help: 'Help',
        choose: '1. Choose a body system.',
        drag: '2. Drag and drop the body parts to build your body system. When your model is finished, use the words to label it.',
        selectDownload: '3. Select “download” to save your model.',
        selectBack:
      '4. Select “back” to return to the main menu. If you have time, choose another body system to build.',
        buildHuman: 'Build a Human',
        start: 'Start',
        chooseSystem: 'Choose a System',
        download: 'download',
        skull: 'skull',
        armBones: 'arm bones',
        ribCage: 'rib cage',
        legBones: 'leg bones',
        lung: 'lung',
        windpipe: 'windpipe',
        mouth: 'mouth',
        nose: 'nose',
        intestines: 'intestines',
        stomach: 'stomach',
        heart: 'heart',
        bloodVessels: 'blood vessels',
        brain: 'brain',
        nerves: 'nerves',
        breathingSystem: 'Breathing System',
        digestiveSystem: 'Digestive System',
        skeletonSystem: 'Skeleton System',
        nerveSystem: 'Nerve System',
        circulatorySystem: 'Circulatory System',
        fullBodySystem: 'Full Body System',
        system: 'system',
    },
    ClimateExplorer: {
        title: 'Climate Explorer',
        Countries: 'Countries',
        LosAngeles: 'Los Angeles, CA, US',
        Seattle: 'Seattle, WA, US',
        Washington: 'Washington, DC, US',
        Pierre: 'Pierre, SD, US',
        StLouis: 'St. Louis, MO, US',
        Lahaina: 'Lahaina, HI, US',
        Nome: 'Nome, AK, US',
        Cincinnati: 'Cincinnati, OH, US',
        Miami: 'Miami, FL, US',
        Sacramento: 'Sacramento, CA, US',
        Dublin: 'Dublin, Ireland',
        Lisbon: 'Lisbon, Portugal',
        Berlin: 'Berlin, Germany',
        Manchester: 'Manchester, UK',
        Warsaw: 'Warsaw, Poland',
        Tromsø: 'Tromsø, Norway',
        Cairo: 'Cairo, Egypt',
        Lagos: 'Lagos, Nigeria',
        CapeTown: 'Cape Town, South Africa',
        Kampala: 'Kampala, Uganda',
        Jerusalem: 'Jerusalem, Middle East',
        Istanbul: 'Istanbul, Turkey',
        Kiev: 'Kiev, Ukraine',
        Moscow: 'Moscow, Russia',
        Yakutsk: 'Yakutsk, Russia',
        Beijing: 'Beijing, China',
        Bangkok: 'Bangkok, Thailand',
        NewDelhi: 'New Delhi, India',
        Singapore: 'Singapore',
        AliceSprings: 'Alice Springs, Australia',
        Adelaide: 'Adelaide, Australia',
        Sydney: 'Sydney, Australia',
        Winnipeg: 'Winnipeg, MB, Canada',
        SantaCruz: 'Santa Cruz de la Sierra, Bolivia',
        Rio: 'Rio de Janeiro, Brazil',
        Córdoba: 'Córdoba, Argentina',
        Manaus: 'Manaus, Brazil',
        PuertoMaldonado: 'Puerto Maldonado, Peru',
        RioGallegos: 'Rio Gallegos, Argentina',
        McMurdo: 'McMurdo Station, Antarctica',
        Tokyo: 'Tokyo, Japan',
        Akureyri: 'Akureyri, Iceland',
        Kinshasa: 'Kinshasa, DR Congo',
        Astana: 'Astana, Kazakhstan',
        PuertoVallarta: 'Puerto Vallarta, Mexico',
        Marrakesh: 'Marrakesh, Morocco',
        SantaFe: 'Santa Fe, NM, US',
        Kufra: 'Kufra, Libya',
        Baghdad: 'Baghdad, Iraq',
        Arica: 'Arica, Chile',
        Latitude: 'Latitude',
        AverageTemperature: 'Average Temperature',
        AverageHigh: 'Average Annual High',
        AverageLow: 'Average Annual Low',
        AnnualPrecipitation: 'Annual Precipitation',
        TemperatureRange: 'Temperature Range',
        Precipitation: 'Precipitation',
    },
    HabitatExplorer: {
        title: 'Habitat Explorer',
        subtitle: 'Choose the habitat',
        great: 'Great!',
        ok: 'Ok',
        foundItemName:
      'You found the item name! Add this <b></b> to the table in your Twig Book.',
        foundName:
      'You found the <b>*CLICKEDITEM*</b>! Add this <b>*TYPE*</b> to the table in your Twig Book.',
        sorry: 'Sorry!',
        incorrect: 'This is not correct.',
        keepSearching: 'Keep searching!',
        left: 'Left',
        right: 'Right',
        foundNonLivingThing:
      'Add this non-living thing to the table in your Twig Book.',
        whatAmI: 'What am I?',
        searchFieldGuide: 'Search the Field Guide and click on me.',
        fieldGuide: 'Field Guide:',
        plant: 'Plant',
        animal: 'Animal',
        nonLivingThing: 'Non-living Thing',
        desert: 'Desert',
        saguaro: 'Saguaro cactus',
        saguaroDescription:
      'The saguaro are tall, tree-like cacti. They are covered in sharp spines. They can store rainwater inside them in order to help them survive for long periods without any rain.',
        pricklyPear: 'Prickly pear cactus',
        pricklyPearDescription:
      'The prickly pear cactus is also known as the “paddle cactus.” They have flat, oval shaped leaves that are known as “pads.” They are native to North and South America.',
        brittlebush: 'Brittlebush',
        brittlebushDescription:
      'The brittlebush is a medium-sized, rounded shrub. The stems of the brittlebush have a liquid that was once used by Native Americans as glue and gum.',
        redTailedHawk: 'Red-tailed hawk',
        redTailedHawkDescription:
      'Red-tailed hawks are common in the desert all year long. Hawks have good eyesight. They hunt rodents, such as mice, and other prey.',
        vulture: 'Vulture',
        vultureDescription:
      'Vultures eat dead animals. They can go several days between meals, using up very little energy as they soar for hours.',
        rattlesnake: 'Rattlesnake',
        rattlesnakeDescription:
      'The rattlesnake has a dangerous venom, like a poison, in its bite. It is known for its rattle-shaped tail, which it uses to make a loud sound that warns off predators.',
        harvesterAnt: 'Harvester ant',
        harvesterAntDescription:
      'Harvester ants live in large groups called colonies. They store food in special areas inside these mounds. An ant can lift many times its own body weight.',
        desertTortoise: 'Desert tortoise',
        desertTortoiseDescription:
      'The desert tortoise has a high-domed shell. They eat plants and can go a long time without food or water. They dig underground burrows to escape the heat.',
        scorpion: 'Scorpion',
        scorpionDescription:
      'A scorpion has pinchers and a long tail with a stinger. Its sting has venom, like poison. It uses its stinger to catch prey, usually insects, and to defend itself.',
        jackrabbit: 'Jackrabbit',
        jackrabbitDescription:
      'Jackrabbits are not actually rabbits. They are hares. They live in open areas and are quite fast. They need their great speed and jumping ability to escape predators.',
        grayFox: 'Gray fox',
        grayFoxDescription:
      'Gray foxes hunt at night. They eat small animals and even some plants. They even climb trees and will sometimes sleep in trees to avoid predators.',
        sand: 'Sand',
        sandDescription:
      'Sands and soils in the desert come in many colors. Some are grey, others are red or pink. They also have different textures.',
        rocks: 'Rocks',
        rocksDescription:
      'In the Sonoran Desert, rocks have been lifted to the surface as the ground was pulled apart in the past. Many animals make these outcroppings their homes.',
        notWater: 'Not a lot of water',
        notWaterDescription:
      'The Sonoran Desert only gets about 8–40 centimeters of rain a year. The moist air that comes from the ocean is almost dry by the time it reaches the desert.',
        hotDay: 'Hot during the day',
        hotDayDescription:
      'In some parts of the desert, it can reach 130° F in the shade during the day. However, at night it cools off and can get below freezing!',
        rainForest: 'Rain Forest',
        rubberTree: 'Rubber tree',
        rubberTreeDescription:
      'The rubber tree produces a milky colored sap which can be collected from the plant once it is about six years old. This sap is what is used to make rubber.',
        palmTree: 'Palm tree',
        palmTreeDescription:
      'Palm trees are the most common trees in the rain forest. The berries are often served with ice cream or chocolate. Yum!',
        kapok: 'Kapok tree',
        kapokDescription:
      'The kapok tree can reach 70 meters in height and around 3 meters in diameter. The trees have smelly flowers that open at night and attract bats.',
        liana: 'Liana',
        lianaDescription:
      'A liana is a long-stemmed woody vine that uses trees to climb to the canopy and reach sunlight. Animals will use these vines as “bridges” to cross from tree to tree.',
        orchid: 'Orchid',
        orchidDescription:
      'Most orchids rely on a single species of bird or bee to pollinate them. If that animal dies out, the orchids are in trouble!',
        bromeliad: 'Bromeliad',
        bromeliadDescription:
      'Bromeliads are flowering plants most commonly found in the Central and South American rain forests. Many store water by creating a structure with their tightly overlapping leaves.',
        fern: 'Fern',
        fernDescription:
      'Ferns are one of the oldest types of plants still found on Earth today. Their leaves are called fronds and they have a root that easily absorbs water and all the nutrients they need.',
        waterLily: 'Water lily',
        waterLilyDescription:
      'Water lilies float on top of the water, with their roots attached to the bottom of the lake or pond. In the rain forest, the flowers stay open day and night until they fade.',
        jaguar: 'Jaguar',
        jaguarDescription:
      'The jaguar is the third largest cat in the world and the largest in North and South America. They mostly hunt alone. Their spots resemble roses and are called rosettes.',
        spiderMonkey: 'Spider monkey',
        spiderMonkeyDescription:
      'Spider monkeys are often seen hanging between trees using all their arms and legs (and their tail!) to hold on, making them look like a spider.',
        glasswingButterfly: 'Glasswing butterfly',
        glasswingButterflyDescription:
      'The glasswing butterfly, has see-through wings that give it its name. Don’t eat it though! It eats toxic berries when it is a caterpillar that make it not fun to snack on.',
        leafCutterAnd: 'Leaf cutter ant',
        leafCutterAntDescription:
      'Leaf cutter ants get their name from their powerful jaws, which can easily snap off pieces of leaves. They also have several spikes on their skin to protect them.',
        toucan: 'Toucan',
        toucanDescription:
      'Rain forest toucans have large brightly colored bills and colorful markings on their feathers. Their bill can sometimes be half as long as their body!',
        treeFrog: 'Tree frog',
        treeFrogDescription:
      'There are more than 1,000 different types of frogs in the rain forest. Most of them live in the trees. They lay their eggs on plants or even on the ground rather than in a pond.',
        piranha: 'Piranha',
        piranhaDescription:
      'There are a lot of scary stories about piranhas. However, they don’t usually eat humans. They snack on both plants and animals, but they only eat larger animals that are already dead.',
        macaw: 'Macaw',
        macawDescription:
      'Macaws are intelligent birds with brightly colored feathers. The patterns of feathers on their faces are also different for each bird, sort of like fingerprints for humans.',
        treeSnake: 'Tree snake',
        treeSnakeDescription:
      'Tree snakes are masters of disguise: they blend into the leafy background of the trees. They are very strong and that helps them hang off branches and catch their prey.',
        anteater: 'Anteater',
        anteaterDescription:
      'Anteaters have long noses and even longer tongues, but no teeth! They use their claws to dig into termite and ant nests and scoop up the insects with their tongue.',
        sloth: 'Sloth',
        slothDescription:
      'There is a reason people use the word “sloth” to describe someone being lazy. These animals move extremely slow and they can sleep up to 18 hours at a time.',
        riverDolphin: 'River dolphin',
        riverDolphinDescription:
      'River dolphins are different from other dolphins that live in the ocean. They are often pink in color and prefer to stay by themselves most of the year rather than in a pod, or group.',
        river: 'River',
        riverDescription:
      'The river is a major feature in many rain forests. Many animals, such as the river dolphin and piranha, make their home there. It is a huge source of the world’s fresh water.',
        soil: 'Soil',
        soilDescription:
      'The rain forest soil is good for supporting the life that lives in it naturally, but it is not good for farming. Not many crops planted by humans will grow well in it.',
        rain: 'Lots of rain',
        rainDescription: 'The rain forest gets over 3 meters of rain every year!',
        warm: 'Warm',
        warmDescription:
      'The rain forest is very warm because it receives a lot of direct sunlight. The sunlight together with the rain, make it a very humid place to live.',
        farm: 'Farm',
        potato: 'Potato',
        potatoDescription:
      'A potato is a plant root that many people like to eat. Most people call it a vegetable. However, it has so much starch in it, it’s more like rice, pasta, or bread.',
        grass: 'Grass',
        grassDescription:
      'There are over 10,000 types of grass. Unlike most other plants, grasses grow from their base instead of their tips. It helps them keep growing despite being mowed or eaten.',
        cottontail: 'Cottontail rabbit',
        cottontailDescription:
      'Rabbit teeth never stop growing, so they have to keep grinding them down as they chew. They are also natural jumpers: some can jump almost 1 meter high.',
        hawk: 'Ferruginous Hawk',
        hawkDescription:
      'Hawks are opportunistic feeders, meaning they eat whatever is available in their habitats. Their diet includes insects, birds, mice, rabbits, frogs, and snakes.',
        cow: 'Cow',
        cowDescription:
      'Cows produce 90% of the milk that people drink. Cows are milked for 3–4 years on average, starting after they have had a calf.',
        bee: 'Bee',
        beeDescription:
      'Bees are very social: a single hive can have as many as 50,000 bees. But watch out! Bees have stingers that they use when they feel threatened.',
        human: 'Human',
        humanDescription:
      'Humans are a type of animal. They can change and influence the Earth in many ways. For example, they develop and care for farms, using them as a source of food.',
        soilFarmDescription:
      'Soils on farms are typically rich in nutrients. That’s why they can grow crops like potatoes or wheat. Farmers till the soil and plant seeds each spring so that the plants will grow.',
        water: 'Water',
        waterDescription:
      'Farmers need to get water to their crops. Some farmers do this using sprinkler systems. They also bring water to their animals in pails and troughs.',
    },
};

export default languageEn;
